import { Component, OnInit, ViewChild } from '@angular/core';
import { MatProgressBar, MatButton } from '@angular/material';
import { Validators, FormGroup, FormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '../../../shared/services/authentication.service';
import 'rxjs/add/operator/first';
import 'rxjs/add/operator/map'

@Component({
  moduleId: module.id,
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.css']
})
export class SigninComponent implements OnInit {
  @ViewChild(MatProgressBar) progressBar: MatProgressBar;
  @ViewChild(MatButton) submitButton: MatButton;

  signinForm: FormGroup;
  model: any = {};
  loading = false;
  returnUrl: string;
  error = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService
  ) { }

  ngOnInit() {
    this.signinForm = new FormGroup({
      username: new FormControl('', Validators.required),
      password: new FormControl('', Validators.required),
      rememberMe: new FormControl(false)

    })
    this.authenticationService.logout();
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
  }

  signin() {
    const signinData = this.signinForm.value
    /* สำหรับ ล็อกอินที่เพิ่มเข้ามา */
    this.loading = true;
    this.authenticationService.login(signinData.username, signinData.password)
      .first()
      .subscribe(
      data => {
        this.router.navigate([this.returnUrl]);
      },
      error => {
        this.error = 'ชื่อเข้าใช้ หรือ รหัสผ่านไม่ถูกต้อง';
        this.loading = false; 
        this.progressBar.mode = 'determinate';
        this.signinForm.patchValue({ password: '',username:'' });
      });

    this.submitButton.disabled = true;
    this.progressBar.mode = 'indeterminate';
  }
}



// WEBPACK FOOTER //
// D:/Programing/carbooking/src/app/views/sessions/signin/signin.component.ts